import type { ApiPathGetter } from "@/models/api";
import type { IState } from "@/store";
import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = `api/admin/notifications/mappings`;
    return { admin };
  }
};

const actions: ActionTree<IDataState, IState> = {
  update: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/update",
      {
        path: `${getters.apiPath().admin}/${payload.mappingId}`,
        storeModule: DataModules.NOTIFICATIONS_MAPPINGS,
        data: payload.data
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
